
import {Component} from "react"
import Helmet from "react-helmet"
import "./ContactUsPage.css"

class ContactUsPage extends Component<any> {

    render() {
        return (
            <div className="info-page-container">
                <Helmet>
                    <title>Contact Us</title>
                    <meta name="description" content="Get in touch with the HomeIndex team. Questions about valuations, feedback or partnership enquiries — we're here to help." />
                    <link rel="canonical" href="https://homeindex.ie/contact" />
                </Helmet>
                <div className="info-content-container">
                    <div className="info-header">
                        <h1 className="info-title">Contact Us</h1>
                        <p className="info-subtitle">We'd love to hear from you</p>
                    </div>
                    
                    <div className="info-content" id="contact-us">
                        <div className="info-card">
                            <div className="info-icon">📧</div>
                            <h2 className="info-card-title">Get in Touch</h2>
                            <p className="info-card-text">
                                Feedback or general queries are welcomed. We're here to help and would love to hear your thoughts about HomeIndex.
                            </p>
                            <div className="info-contact-details">
                                <div className="info-contact-item">
                                    <span className="info-contact-label">Email:</span>
                                    <a href="mailto:info@homeindex.ie" className="info-contact-link">
                                        info@homeindex.ie
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                        <div className="info-card">
                            <div className="info-icon">💬</div>
                            <h2 className="info-card-title">What We're Looking For</h2>
                            <ul className="info-list">
                                <li>Feedback on house valuations</li>
                                <li>Suggestions for new features</li>
                                <li>Bug reports and technical issues</li>
                                <li>General questions about property values</li>
                                <li>Partnership opportunities</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ContactUsPage
